export const SITE_NAME = "Experts4Europe";
export const SITE_ORIGIN = "https://www.experts4europe.com";
export const DEFAULT_OG_IMAGE = `${SITE_ORIGIN}/logo512.png`;

const DEFAULT_DESCRIPTION =
  "Experts4Europe unterstützt Fachkräfte bei beruflichen Wegen nach Europa und Arbeitgeber bei strukturierter internationaler Rekrutierung.";

const indexableRoutes = {
  "/": {
    title: "Experts4Europe | Faire Infrastruktur für internationale Fachkräfteeinwanderung",
    description:
      "Experts4Europe ist die strukturierte, faire und KI-gestützte Infrastruktur für internationale Fachkräfteeinwanderung nach Europa.",
    type: "website",
    image: DEFAULT_OG_IMAGE,
    structuredData: [
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: SITE_NAME,
        url: SITE_ORIGIN,
        logo: DEFAULT_OG_IMAGE,
        sameAs: [],
      },
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: SITE_NAME,
        url: SITE_ORIGIN,
        inLanguage: "de",
      },
    ],
  },
  "/leitbild": {
    title: "Leitbild | Experts4Europe",
    description:
      "Mission, Vision und Werte von Experts4Europe: faire Bedingungen, gute Vorbereitung, Respekt vor Qualifikation und verantwortungsvolle internationale Rekrutierung.",
    type: "article",
    image: DEFAULT_OG_IMAGE,
    structuredData: [
      {
        "@context": "https://schema.org",
        "@type": "AboutPage",
        name: "Leitbild von Experts4Europe",
        url: `${SITE_ORIGIN}/leitbild`,
        inLanguage: "de",
      },
    ],
  },
  "/applicant/frontdoor": {
    title: "Applicant Quick Check | Experts4Europe",
    description:
      "Applicant Frontdoor von Experts4Europe: schneller Quick Check fuer Fachkraefte mit erster Pfadeinordnung, Readiness und konkreten naechsten Schritten.",
    type: "website",
    image: DEFAULT_OG_IMAGE,
    structuredData: [
      {
        "@context": "https://schema.org",
        "@type": "WebPage",
        name: "Applicant Quick Check",
        url: `${SITE_ORIGIN}/applicant/frontdoor`,
        inLanguage: "de",
      },
    ],
  },
  "/stb/job-marketplace": {
    title: "Stellenbörse | Experts4Europe",
    description:
      "Öffentliche Stellenbörse von Experts4Europe mit offenen Chancen für internationale Fachkräfte in Europa.",
    type: "website",
    image: DEFAULT_OG_IMAGE,
    structuredData: [
      {
        "@context": "https://schema.org",
        "@type": "CollectionPage",
        name: "Experts4Europe Stellenbörse",
        url: `${SITE_ORIGIN}/stb/job-marketplace`,
        inLanguage: "de",
      },
    ],
  },
  "/menue/tools": {
    title: "Tools für Bewerber und Arbeitgeber | Experts4Europe",
    description:
      "KI-gestützte Tools für Lebenslauf, Dokumente, Matching und Recruiting auf Experts4Europe.",
    type: "article",
    image: DEFAULT_OG_IMAGE,
  },
  "/menue/quali": {
    title: "Qualifikationen in Europa sichtbar machen | Experts4Europe",
    description:
      "Wie Experts4Europe bei Qualifikationen, Sprachstand und beruflicher Sichtbarkeit in Europa unterstützt.",
    type: "article",
    image: DEFAULT_OG_IMAGE,
  },
  "/menue/success": {
    title: "Erfolgsgeschichten und Chancen | Experts4Europe",
    description:
      "Wie Fachkräfte mit Experts4Europe ihren nächsten Karriereschritt in Europa erreichen können.",
    type: "article",
    image: DEFAULT_OG_IMAGE,
  },
  "/menue/support": {
    title: "Support und Begleitung | Experts4Europe",
    description:
      "Hilfen, Begleitung und klare nächste Schritte für internationale Fachkräfte und Arbeitgeber auf Experts4Europe.",
    type: "article",
    image: DEFAULT_OG_IMAGE,
  },
};

const noindexRoutes = {
  "/login": {
    title: "Anmelden | Experts4Europe",
    description: "Zugang zu Ihrem Experts4Europe-Bereich für Bewerber, Arbeitgeber und Administration.",
  },
  "/register": {
    title: "Registrierung | Experts4Europe",
    description: "Rollenbasierten Experts4Europe-Zugang für Bewerber oder Arbeitgeber anlegen.",
  },
  "/impressum": {
    title: "Impressum | Experts4Europe",
    description: "Rechtliche Informationen zu Experts4Europe.",
  },
  "/agb": {
    title: "AGB | Experts4Europe",
    description: "Allgemeine Geschäftsbedingungen von Experts4Europe.",
  },
  "/datenschutz": {
    title: "Datenschutz | Experts4Europe",
    description: "Datenschutzhinweise von Experts4Europe.",
  },
};

export const PRERENDER_ROUTES = Object.keys(indexableRoutes);

export function getRouteSeo(pathname) {
  if (indexableRoutes[pathname]) {
    return {
      siteName: SITE_NAME,
      canonical: `${SITE_ORIGIN}${pathname === "/" ? "" : pathname}`,
      robots: "index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1",
      ...indexableRoutes[pathname],
    };
  }

  if (noindexRoutes[pathname]) {
    return {
      siteName: SITE_NAME,
      canonical: `${SITE_ORIGIN}${pathname === "/" ? "" : pathname}`,
      robots: "noindex,nofollow,noarchive",
      type: "website",
      image: DEFAULT_OG_IMAGE,
      structuredData: [],
      ...noindexRoutes[pathname],
    };
  }

  if (
    pathname.startsWith("/dashboard") ||
    pathname.startsWith("/assessment") ||
    pathname.startsWith("/admin")
  ) {
    return {
      siteName: SITE_NAME,
      title: `${SITE_NAME} | Interner Bereich`,
      description:
        "Geschützter Bereich von Experts4Europe für Bewerber, Arbeitgeber und Admin-Nutzer.",
      canonical: `${SITE_ORIGIN}${pathname}`,
      robots: "noindex,nofollow,noarchive",
      type: "website",
      image: DEFAULT_OG_IMAGE,
      structuredData: [],
    };
  }

  return {
    siteName: SITE_NAME,
    title: `${SITE_NAME} | Europaweite Talentplattform`,
    description: DEFAULT_DESCRIPTION,
    canonical: `${SITE_ORIGIN}${pathname === "/" ? "" : pathname}`,
    robots: "noindex,nofollow,noarchive",
    type: "website",
    image: DEFAULT_OG_IMAGE,
    structuredData: [],
  };
}
